import styled from 'styled-components';

import { getColor, getSpace, getTextType, mq } from '@stylesheets/tools';

import { getGradientOutline } from '../../wishes.style';

const StyledEvaluation = styled.div`
  --category-color: ${getColor('pink')};
  .evaluation__top-wishes,
  .evaluation__top-categories {
    display: flex;
    flex-wrap: wrap;
  }

  .evaluation__total-text * {
    margin-inline: 0;
  }

  .evaluation__top-categories {
    margin-bottom: ${getSpace('l')};
    gap: ${getSpace('xs')};
  }

  .evaluation__category {
    background: var(--category-color);
    padding: ${getSpace('xxxs')} ${getSpace('xxs')};
    border-radius: 6px;
    flex-basis: 100%;
    display: flex;
    align-items: center;
    gap: ${getSpace('m')};

    ${mq('m')} {
      padding: ${getSpace('xxs')};
    }

    &-text h3 {
      font-size: 36px;
      line-height: 1;
      margin-bottom: ${getSpace('xxxxs')};

      ${mq('m')} {
        font-size: 52px;
      }
    }

    &-text p {
      ${getTextType('copy')};
      line-height: 19px !important
      font-weight: 400;
      text-transform: uppercase;
    }

    &-image {
      width: 100px;
      height: 100px;
      border-radius: 50%;

      ${mq('m')} {
        width: 130px;
        height: 130px;
      }
    }

    &:nth-child(2) h3 {
      font-size: 28px;

      ${mq('m')} {
        font-size: 46px;
      }
    }

    &:nth-child(3) h3 {
      font-size: 22px;

      ${mq('m')} {
        font-size: 32px;
      }
    }

    &:nth-child(n + 4) {
      flex-basis: 100%;

      ${mq('m')} {
        flex-basis: calc(50% - (${getSpace('xs')} / 2));
        flex-direction: column;
        justify-content: center;
        gap: ${getSpace('xxs')};
      }

      .evaluation__category-text {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        h3 {
          order: 2;
          font-size: 16px;
          line-height: 1;
          flex-shrink: 0;

          ${mq('m')} {
            font-size: 22px;
          }
        }

        ${mq('m')} {
          display: block;
          text-align: center;
        }
      }

      .evaluation__category-image {
        width: 40px;
        height: 40px;

        ${mq('m')} {
          width: 60px;
          height: 60px;
        }
      }
    }
  }

  .evaluation__top-wishes {
    gap: ${getSpace('m')};
  }

  .evaluation__wish {
    position: relative;
    flex-basis: 100%;
    padding-left: ${getSpace('xs')};

    &:first-child {
      margin-top: ${getSpace('xxs')};
    }

    &-text {
      ${getGradientOutline()};

      > p,
      > h3 {
        position: relative;
        border: none;
        width: 100%;
        background: ${getColor('white')};
        padding: ${getSpace('xxxs')} ${getSpace('xxs')};
        border-radius: 2px;
        ${getTextType('copy')};
        line-height: 19px !important;
        font-weight: 400;
      }
    }

    &-number {
      position: absolute !important;
      top: -8px;
      left: 10px;
      ${getGradientOutline()};

      &:before {
        border-radius: 2px;
      }

      > p,
      > .evaluation__wish-svg {
        position: relative;
        background: ${getColor('white')};
        border-radius: 2px;
        width: 18px;
        height: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        ${getTextType('copySmall')};
        font-weight: 400;
      }
    }
  }

  .evaluation__personal {
    position: relative;
    width: 100%;
    height: 100%;

    ${mq('m')} {
      position: absolute;
      top: 0;
      right: 100%;
      border: 2px solid ${getColor('darkGray')};
      background-color: ${getColor('white')};
      box-shadow: 0 2px 4px rgba(0, 10, 20, 0.1);
      border-radius: 10px;
      overflow-y: auto;
      width: 300px;
    }

    ${mq('l')} {
      width: 380px;
    }

    .evaluation__wish {
      z-index: 1;
      padding-right: ${getSpace('xxs')};
    }

    .evaluation__wish-number {
      top: -15px;
      left: 4px;
    }

    .evaluation__wish-number:before {
      border-radius: 50%;
    }

    .evaluation__wish-svg {
      width: 29px;
      height: 29px;
      border-radius: 50%;

      svg {
        width: 16px;
      }
    }
  }

  .evaluation__personal {
    margin-bottom: ${getSpace('m')};
  }

  .evaluation__personal-content {
    margin-top: ${getSpace('m')};
  }

  .evaluation__personal-inner {
    ${mq('m')} {
      padding: ${getSpace('m')} ${getSpace('s')} ${getSpace('s')};
    }

    h2 {
      display: none;

      ${mq('m')} {
        display: block;
      }
    }
  }

  .evaluation__personal-image {
    margin-top: -25px;
    margin-bottom: ${getSpace('s')};

    &-inner {
      position: relative;
      aspect-ratio: 16 / 9;
      background: linear-gradient(white, white) padding-box,
        linear-gradient(90deg, #606ded 5.89%, #72f2ed 49.35%, #ceef30 88.54%) border-box;
      border-radius: 8px;
      border: 2px solid transparent;
      overflow: hidden;
    }

    img {
      position: relative;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    figcaption {
      margin-top: ${getSpace('xxxxs')};
    }
  }

  .evaluation__personal-meta {
    display: flex;
    flex-wrap: wrap;
    gap: ${getSpace('xxxs')};
    margin-bottom: ${getSpace('xxs')};

    &-item {
      position: relative;
      ${getGradientOutline()};

      p {
        position: relative;
        background: ${getColor('white')};
        border-radius: 4px;
        padding: ${getSpace('xxxxs')} ${getSpace('xxxs')};
        text-transform: uppercase;
        margin-bottom: 0;
      }
    }
  }

  .not-mobile {
    display: none;

    ${mq('m')} {
      display: block;
    }
  }

  .not-desktop {
    display: block;

    ${mq('m')} {
      display: none;
    }
  }

  // React tabs overwrites
  .react-tabs__tab-list {
    list-style: none;
    margin: 0;
    padding: 0;
    margin-top: ${getSpace('xs')};

    ${mq('m')} {
      margin-top: ${getSpace('l')};
    }

    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: ${getSpace('xxxxs')};
  }

  .react-tabs__tab {
    padding: ${getSpace('xxxxs')} ${getSpace('xxxs')};
    background: ${getColor('gray')};
    border-radius: 50px;
    ${getTextType('copyExtraSmall')};
    font-weight: 400;
    text-transform: uppercase;
    text-align: center;
    min-width: 58px;

    ${mq('m')} {
      padding: ${getSpace('xxxs')} ${getSpace('xxs')};
      min-width: 85px;
    }

    &--selected {
      background: ${getColor('black')};
      color: ${getColor('white')};
    }
  }

  .react-tabs__tab-panel {
    margin-top: ${getSpace('s')};

    ${mq('m')} {
      margin-top: ${getSpace('m')};
    }
  }

  // wishes button mobile override
  .wishes__button {
    ${mq('m', 'max')} {
      width: 30px;
      border-radius: 50%;
      padding: 0;
    }

    span {
      ${mq('m', 'max')} {
        display: none;
      }
    }
  }
`;

export default StyledEvaluation;
